import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {GoBackHeaderTitle} from '../../Molecules/ViewComponents/ViewHeader'
import {Label, LabelInputWrapper, LabelTextArea} from '../../Atoms/Forms'
import AssetWidget, {AssetGroup} from '../Assets/AssetWidget'
import DocumentWidget from '../Assets/DocumentWidget'
import TaskLinks from './TaskLinks'
import RichTextInstructionsEditor from './RichTextInstructionsEditor'
import {normalizeInstructions, TASK_INSTRUCTIONS_MAX_LENGTH} from '../../../types/richTextInstructions'

export interface AnyObject {
  [key: string]: any
}

export const TasksGoBackHeaderTitle = ({
  label,
  isEditing,
  backPath,
  backLabel
}: {
  label: string
  isEditing: boolean
  backPath?: string
  backLabel?: string
}) => {
  const {t} = useTranslation('tasks')
  return (
    <GoBackHeaderTitle
      label={label}
      path={backPath || (isEditing ? '/edit/tasks' : '/create/task')}
      backLabel={
        backLabel ||
        (isEditing
          ? t('tasks:labels.taskSettings', 'Tasks settings')
          : t('tasks:labels.selectTaskTypeTitle', 'Select task type'))
      }
    />
  )
}

export const CommonInformationFields = ({useForm}: {useForm: AnyObject}) => {
  const {t} = useTranslation(['tasks', 'assets'])
  const fc = useForm
  const {register} = fc

  const MAX_LENGTHS = {description: 1000}

  useEffect(() => {
    register('instructions')
  }, [register])

  return (
    <>
      <LabelInputWrapper>
        <Label>
          {t(
            'tasks:labels.addImageVideoLinkDocument',
            'Add image / video, link or a document for task information. Added details will appear on the task.'
          )}
        </Label>
      </LabelInputWrapper>
      <AssetGroup>
        <DocumentWidget handleRemove={fc.removeAsset} handleAdd={fc.addSelectedAsset} savedAssets={fc.assets || []} />
        <AssetWidget
          handleRemove={fc.removeAsset}
          handleAdd={fc.addSelectedAsset}
          savedAssets={(fc.assets || []).filter((a: any) => a.assetType === 'photo' || a.assetType === 'video')}
        />
        <TaskLinks
          ref={fc.register({required: true})}
          hasLinks={!!fc.form.linkDescription}
          hasErrors={!!fc.errors.linkDescription || !!fc.errors.linkUrl}
        />
      </AssetGroup>
      <RichTextInstructionsEditor
        value={normalizeInstructions(fc.form.instructions)}
        onChange={instructions => fc.setValue('instructions', instructions, true)}
        disabled={fc.editingDisabled}
        label={t('tasks:labels.taskInstructions', {
          defaultValue: 'Instructions (max {{length}} characters)',
          length: TASK_INSTRUCTIONS_MAX_LENGTH
        })}
      />
      <LabelTextArea
        name="description"
        labelText={t('tasks:labels.taskDescription', {
          defaultValue: 'What you need (max {{length}} characters)',
          length: MAX_LENGTHS.description
        })}
        id="description"
        ref={fc.register}
        maxLength={MAX_LENGTHS.description}
      />
      <Label>{`${fc.form.description?.length || 0} / ${MAX_LENGTHS.description}`}</Label>
    </>
  )
}
